import { Table } from '@backstage/core-components';
import { makeStyles } from '@material-ui/core';
import { portfolioColumns, PortfolioColumnContext } from './portfolioColumns';
import type { PortfolioFilters } from './usePortfolioFilters';
import type { usePortfolioQueries } from './usePortfolioQueries';

const useStyles = makeStyles({
  tableContainer: {
    width: '100%',
    minWidth: 0,
    overflowX: 'hidden',
    '& table': { tableLayout: 'fixed', width: '100%' },
    '& th, & td': { overflow: 'hidden' },
  },
});

export function PortfolioTable(
  props: PortfolioColumnContext & {
    filterState: PortfolioFilters;
    queries: ReturnType<typeof usePortfolioQueries>;
  },
) {
  const classes = useStyles();
  const { filterState, queries, selection } = props;
  const { filters } = filterState;
  return (
    <section
      className={classes.tableContainer}
      aria-label="Tabela de atividades"
    >
      <Table
        title={`${queries.total} atividade${queries.total !== 1 ? 's' : ''}`}
        columns={portfolioColumns(props)}
        data={queries.activities}
        options={{
          paging: true,
          pageSize: filters.limit ?? 20,
          search: false,
          padding: 'dense',
          tableLayout: 'fixed',
        }}
        page={(filters.page ?? 1) - 1}
        totalCount={queries.total}
        onPageChange={page => {
          selection.clear();
          filterState.changePage(page);
        }}
        onRowsPerPageChange={limit => {
          selection.clear();
          filterState.change({ limit });
        }}
      />
    </section>
  );
}
